var map = {
	"./Alcohol_Recall_3_Set.png": "3d87",
	"./Automotive_Recall_3_Set.png": "7b3f",
	"./CPG_Recall_3_Set.png": "f166",
	"./Education_Recall_3_Set.png": "591d",
	"./Entertainment_Recall_3_Set.png": "6d88",
	"./Fashion_Recall_3_Set.png": "4634",
	"./Financial_Recall_3_Set.png": "bf78",
	"./Health & Beauty_Recall_3_Set.png": "bd91",
	"./Home Improvements_Recall_3_Set.png": "8266",
	"./Media_Recall_3_Set.png": "28cd",
	"./Real State_Recall_3_Set.png": "165c",
	"./Restaurants_Recall_3_Set.png": "30ff",
	"./Retail_Recall_3_Set.png": "c63b",
	"./Services_Recall_3_Set.png": "1ca2",
	"./Telecom_Recall_3_Set.png": "fcad",
	"./Travel_Recall_3_Set.png": "29c3",
	"./Utilities_Recall_3_Set.png": "9a2d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0a35";